import { Component, OnInit, Input} from '@angular/core';
import { FormGroup,  FormBuilder,  Validators } from '@angular/forms';
import { ReportService } from '../_services/report.service';
import { first } from 'rxjs/operators';
import { NgxNotificationService } from 'ngx-notification';

@Component({
  selector: 'app-products',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  @Input() OnlyNumber: boolean;
  contactForm : FormGroup;
  loading = false;
  submitted = false;
  constructor(private reportService: ReportService, private fb: FormBuilder, private ngxNotificationService: NgxNotificationService) { }

  createForm() {
    this.contactForm = this.fb.group({
       fullname: ['', Validators.required],
       email: ['', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"), Validators.required]],
       subject: ['', Validators.required],
       message: ['', Validators.required] 
    });
  }
  
  ngOnInit() {
    this.createForm();
  }

  get f() { return this.contactForm.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.contactForm.invalid) {
      return;
    }

    this.loading = true;

    this.reportService.sendReport(this.contactForm.value)
      .pipe(first())
      .subscribe(
        data => {
          if (data !== null && data !== undefined) {
            this.ngxNotificationService.sendMessage('We have received your email!', 'success', 'bottom-left');
            this.submitted = false;
            this.contactForm.reset();
          } else {
            this.ngxNotificationService.sendMessage('Could not get response from server. Try Again', 'warning', 'bottom-left');
            this.loading = false;
          }
        },
        error => {
          this.ngxNotificationService.sendMessage('Could not get response. Try Again', 'danger', 'bottom-left');
          this.loading = false;
          console.log(error);
        });
  }
}
